import styled from "styled-components";
import { Button, Form, Input, InputNumber, Select, DatePicker } from "antd";
import PropTypes from "prop-types";
import { useApp } from "../../contexts";

export const FormRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
  height: 52px;
  background: #ffffff;
  border-radius: 10px;
  border: none;
  padding-left: 22px;
  font-size: 16px;
`

export const FormItem = styled(Form.Item)`
  & .ant-form-item-row {
    display: block;
  }
  & label {
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    color: #818181;

    &::after {
      display: none;
    }
  }
  &.address-booking-row{
    margin-bottom: 16px !important;
    .ant-form-item-label{
      padding-bottom: 0px !important;
    }
  }
`;

export const FormButton = styled(Button)`
  height: 52px;
  min-width: 160px;
  box-shadow: none;
  background: #000 !important;
  border-radius: 15px !important;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff !important;
  border: none;

  &.ant-btn[disabled] {
    opacity: 0.5 !important;
    border: none;
    color: #bfbfbf !important;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const FormDatePicker = styled(DatePicker).attrs((props) => ({
  suffixIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8333 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V16.6668C2.5 17.5873 3.24619 18.3335 4.16667 18.3335H15.8333C16.7538 18.3335 17.5 17.5873 17.5 16.6668V5.00016C17.5 4.07969 16.7538 3.3335 15.8333 3.3335Z"
        stroke="black"
        stroke-opacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 1.6665V4.99984"
        stroke="black"
        stroke-opacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 1.6665V4.99984"
        stroke="black"
        stroke-opacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.3335H17.5"
        stroke="black"
        stroke-opacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}))`
  width: 100%;
  height: 52px;
  background: #ffffff;
  border-radius: 10px;
  border: none;
  padding-left: 22px;
  font-size: 16px;
`;

export const FormButtonCancel = styled(Button)`
  height: 52px;
  min-width: 250px;
  background: #000000;
  border-radius: 10px;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #fff;
  border: none;
  &:hover {
    background: #000000;
    color: #fff;
    opacity: 0.8;
  }
  &[disabled] {
    opacity: 0.5;
  }
`;

export const FormInput = styled(Input)`
  height: 50px;
  background: #ffffff;
  border-radius: 10px;
  border: none;
  padding-left: 22px;
  font-size: 16px;
  &.generate-input {
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    box-shadow: none;
    outline: none;
  }
  & .ant-input-suffix {
    font-weight: 400;
    font-size: 14px;
    line-height: 25px;
    color: rgba(112, 112, 112, 0.8);
  }
`;

export const FormInputNumber2 = styled.input.attrs({
  // type: "number"
})`
  height: 52px;
  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(77, 103, 193, 0.14902);
  border-radius: 10px !important;
  border: none;
  padding-left: 22px;
  width: 100%;
  font-size: 16px;
  outline: none;
  transition: all 0.3s;

  &:hover {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
    border-right-width: 1px;
    outline: 0;
  }
`;

const InputNumberC = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  & .ant-input-number-group-addon {
    display: none;
  }

  & > input {
    height: 52px;
    width: calc(100% - 60px);
    opacity: 0;
    border: none;
    outline: none;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: red;
    font-size: 16px;
  }
`;

const DivAddonAfter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  text-align: right;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  min-width: 100px;
  padding-right: 16px;
  height: 50px;
  position: absolute;
  bottom: 0px;
  right: 0;
  z-index: 10;

  span {
    color: #818181;
  }

  & div {
    background: #F12E11;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
  }
`;

export const FormInputNumberRaw = (props) => {
  const { T } = useApp();
  const { 
    step = "0.00000001",
    onAll,
    textAll,
    extra,
    autoFocus,
    ...restProps
  } = props;
  return (
    <InputNumberC>
      <FormInputNumber
        step={step}
        min={0}
        autoFocus={autoFocus}
        // inputMode="decimal"
        lang="en-US"
        decimalSeparator={"."}
        formatter={(value) =>
          value
            ? new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 8,
              }).format(value)
            : ""
        }
        parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
        onChange={(event) => {
          let number = event;
          props.onChange(number);
        }}
        value={props.value}
        placeholder={props.placeholder}
        {...restProps}
      />
      <DivAddonAfter>
        {props.addonAfter ? <span>{props.addonAfter}</span> : null}
        {onAll ? (
          <div onClick={onAll}>{T(textAll ?? "Max")}</div>
        ) : null}
      </DivAddonAfter>
      {extra && <span className='input-extra'>{extra}</span>}
    </InputNumberC>
  );
};

FormInputNumberRaw.propTypes = {
  step: PropTypes.string,
  onAll: PropTypes.func,
  textAll: PropTypes.string,
  extra: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string,
  addonAfter: PropTypes.node,
};

export const FormInputNumber = styled(InputNumber)`
  width: 100%;
  overflow: hidden;

  & .ant-input-number {
    height: 52px;
    background: #ffffff;
    box-shadow: none;
    outline: none;
    border-radius: 10px !important;
    border: none;
    padding-left: 22px;
    width: 100%;
    overflow: hidden;
  }

  & .ant-input-number.ant-input-number-focused::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 1px;
    background: #000;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: 1;
  }

  & .ant-input-number-handler-wrap {
    display: none;
  }

  & .ant-input-number-group-addon {
    font-weight: 400;
    font-size: 14px;
    line-height: 52px;
    color: rgba(112, 112, 112, 0.8);
    background: none;
    border: none;
    position: absolute;
    right: 0;
    width: 80px;
    padding: 0;
    text-align: right;
    padding-right: 22px;
    z-index: 1;
  }

  & .ant-input-number-input {
    padding: 0;
    height: 52px;
    line-height: 52px;
    padding-right: 100px;
    font-size: 16px;
    position: relative;
    z-index: 3;
  }

  & input::-webkit-input-placeholder {
    font-size: 16px;
    color: #a3a3a3;
    font-weight: 400;
    line-height: 25px;
    @media (max-width: 640px) {
      font-size: 14px;
    }
  }
`;

export const FormSelect = styled(Select).attrs((props) => ({
  suffixIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="black"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}))`
  font-size: 16px;

  &.ant-select-single .ant-select-selector {
    height: 52px !important;
    background: #ffffff !important;
    box-shadow: none;
    border-radius: 10px !important;
    border: none !important;
    padding-left: 22px !important;
    overflow: hidden;
    position: relative;
  }
  &.generate-select.ant-select-single .ant-select-selector {
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    .ant-select-selection-item{
      display: flex;
      align-items: center;
    }
  }

  &.ant-select-single.ant-select-focused .ant-select-selector::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 1px;
    background: #000;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  &.ant-select-single.ant-select-focused .ant-select-selector {
    box-shadow: none !important;
    outline: none !important;
  }
  &.input-mint.ant-select-single .ant-select-selector {
    background-color: #f5f5f5 !important;
    @media screen and (max-width: 992px) {
      background-color: #fff !important;
    }
  }
  &.ant-select-single .ant-select-selector .ant-select-selection-search-input {
    height: 50px;
  }
  &.input-mint.ant-select-single
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 50px;
  }
  &.input-search-sub.ant-select-single .ant-select-selector {
    background-color: #ffffff !important;
    @media screen and (max-width: 992px) {
      background-color: #fff !important;
    }
  }
  &.input-search-sub.ant-select-single
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 40px;
  }
  &.input-search-sub.ant-select-single .ant-select-selector {
    height: 40px !important;
    width: 250px !important;
  }
  &.input-search-sub.ant-select-single
    .ant-select-selector
    .ant-select-selection-item,
  &.input-search-sub.ant-select-single
    .ant-select-selector
    .ant-select-selection-placeholder {
    line-height: 40px;
  }
  &.input-mint.no-arrow.ant-select-single .ant-select-arrow {
    display: none !important;
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-item,
  &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 52px;
  }
  & .ant-select-selection-item {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #000000;
  }
`;

export const FormItemRow = styled(Form.Item).withConfig({
  shouldForwardProp: (prop) => prop !== 'oneRow',
})`
  &.ant-form-item {
    margin-bottom: 20px;
    &.column-reserved{
      .ant-form-item-control{
        flex-direction: column-reverse;
      }
      .ant-form-item-explain-connected{
        order: 1;
      }
      .ant-form-item-control-input{
        order: 2;
      }
      .ant-form-item-extra{
        order: 3;
      }
    }
  }

  & .ant-form-item-label {
    text-align: left;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;

    & label {
      font-weight: 400;
      font-size: 15px;
      line-height: 25px;
      color: #818181;
    }

    @media screen and (max-width: 1024px) {
      & {
        height: auto;
      }
    }
  }

  & .ant-col.ant-form-item-control {
    display: flex;
    flex: ${(props) => props.oneRow ? "none" : "auto"};
  }

  @media (max-width: 575px) {
    && .ant-form-item-label {
      flex: none;
    }
   }

  &.input-amount {
    .ant-form-item-explain-error {
      font-style: italic;
    }
  }
  &.input-row-mint {
    & .ant-form-item-row {
      display: block;
    }
    .ant-form-item-label {
      padding-bottom: 2px;
      width: 100%;
      label{
        width: 100%;
      }
    }
    &.column-reserved{
      .ant-form-item-control{
        flex-direction: column-reverse;
      }
    }
  }
  &.no-after{
    .ant-form-item-label > label {
      &::after{
        display: none !important;
      }
    }
  }

  && .ant-row {
    flex-direction: ${(props) => props.oneRow ? "row" : "column"};
    justify-content: ${(props) => props.oneRow ? "space-between" : "flex-start"};
  }
`;
